<template>
    <div class="card border-0 bg-wash no-shadow">
        <div class="card-body no-gutters px-0">
            <div class="float-left ml-0 custom-search col-md-6">
                <b-input-group class="mb-2">
                    <b-input-group-prepend is-text>
                        <b-icon icon="search"></b-icon>
                    </b-input-group-prepend>
                    <b-form-input type="search" placeholder="Search Message" v-model="search" @input="resetPagination()"></b-form-input>
                </b-input-group>
            </div>
            <div class="float-right col-md-6 text-right pr-0">
                <b-button id="show-btn" v-if="ce" @click="addNewMsg()"><b-icon icon="plus" ></b-icon> Setup New Message</b-button>
            </div>
        </div>

        <b-alert show dismissible fade v-if='successmsg'>{{successmsg}}</b-alert>

        <b-overlay :show="showoverlay" rounded="sm" class="card-body container p-0">
            <div class="card-body container-fluid p-0">
                <div class="row table-head py-2 no-margin">
                    <div class="col-sm-1 py-1 pl-2 font-weight-bold align-self-center">                
                        Type
                    </div>                
                    <div class="col-sm-1 py-1 align-self-center font-weight-bold ">
                        Priority
                    </div>
                    <div class="col-sm-2 py-1 pl-1 font-weight-bold align-self-center">
                        Start Date
                    </div>
                    <div class="col-sm-2 py-1 font-weight-bold align-self-center">
                        End Date
                    </div>
                    <div class="col-sm-4 py-1 font-weight-bold align-self-center">
                        Message
                    </div>
                    <div class="col-sm-2 py-1 pl-2 font-weight-bold text-right">                
                        Action
                    </div>
                </div>

                
                <div class="row border-bottom py-10 hover-bg table-row border-bottom no-margin" v-for="msg in paginatedData" :key="msg.id">

                    <div class="col-sm-1 py-1 pl-2 align-self-center">                
                        {{types[msg.type].text}}
                    </div>                
                    <div class="col-sm-1 py-1 align-self-center">
                        {{prioritys[msg.priority].text}}
                    </div>
                    <div class="col-sm-2 py-1 pl-1 align-self-center">
                        {{msg.start_date}}
                    </div>
                    <div class="col-sm-2 py-1 align-self-center">
                        {{msg.end_date}}
                    </div>
                    <div class="col-sm-4 py-1 align-self-center">
                        {{msg.message}}
                    </div>
                    <div class="col-sm-2 py-1 pl-2">
                        <div class="float-right position-relative">
                            <b-button-toolbar>
                                <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle" style="font-size: 16px;" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><b-icon icon="three-dots-vertical"></b-icon></a>
                                <div class="dropdown-menu action-dropdown-menu" aria-labelledby="actionDropdown">
                                    <b-button-group >
                                        <b-button variant="outline-secondary" v-if="ce" @click="editMsg(msg.id)">
                                            <b-icon icon="pencil"></b-icon> Edit
                                        </b-button>

                                        <b-button variant="outline-secondary" v-if="ce" @click="deleteMsg(msg.id)">
                                            <b-icon icon="trash-fill"></b-icon> Delete
                                        </b-button>
                                    </b-button-group>
                                </div>
                            </b-button-toolbar>
                         </div>
                    </div>
                </div>
                
                <div class="row p-2 float-right" v-if="paginatedData.length > 0">
                    <b-pagination-nav  v-model="pagination.currentPage" :number-of-pages="pagination.pages" base-url="#" prev-text="Previous" next-text="Next" first-number last-number ></b-pagination-nav>
                </div>
                <div class="row p-2" v-if="paginatedData.length == 0">
                    {{blankmsg}}
                </div>
            </div>
        </b-overlay>
        
        
        <b-modal id="bv-modal-example" size="lg" hide-footer title="Message Details">
            

                <!--<ul class="list-group mb-3 " v-if='errormsg'>           
                    <li class="list-group-item list-group-item-danger" v-for='data in errormsg'>{{data[0]}}</li>
                </ul>-->

                <b-overlay :show="showoverlaymodal" rounded="sm">
                    <b-form @submit.stop.prevent="onSubmit">
                        <input type="hidden" v-model="fdata.id" name="id">                        

                        <b-form-group id="type-group" class="half-width mr1" label="Type" label-for="type">
                            <b-form-select id="type" name="type" v-model="fdata.type" :options="types" ></b-form-select>
                        </b-form-group>

                        <b-form-group id="priority-group" class="half-width" label="Priority" label-for="priority">
                            <b-form-select id="priority" name="priority" v-model="fdata.priority" :options="prioritys"></b-form-select>
                        </b-form-group>

                        <b-form-group id="start_date-group" class="half-width mr1" label="Start Date" label-for="start_date">
                            <b-form-datepicker id="start_date"  v-model="fdata.start_date" ></b-form-datepicker>
                        </b-form-group>

                        <b-form-group id="end_date-group" class="half-width" label="End Date" label-for="end_date">
                            <b-form-datepicker id="end_date" v-model="fdata.end_date"></b-form-datepicker>
                        </b-form-group>

                        <b-form-group id="message-group" class="half-width" label="Message" label-for="message">
                            <b-form-textarea id="message" name="message" v-model="fdata.message" v-validate="{ required: true, min: 3 }" :state="validateState('message')" aria-describedby="message-feedback" data-vv-as="Message"></b-form-textarea>
                            <b-form-invalid-feedback id="message-feedback">{{ veeErrors.first('message') }}</b-form-invalid-feedback>
                        </b-form-group>
                         <div class="full-width">
                            <b-button type="submit" variant="success">Submit</b-button>
                            <b-button class="ml-2" variant="success" @click="resetForm()">Reset</b-button>
                         </div>
                    </b-form> 
                </b-overlay>               
        </b-modal>

    </div>
</template>


<script>
    export default{
        
        mounted() {
            //console.log('Bank info started..');   
            //console.log(this.employee_id);  
            
        },
        props: [],
        data(){            
            
            return {
                cu : window.location.href,
                ce : false, 
                
                
                pagetitle: '',
                search:'',
                listdata : [],                 
                messages : [],                 
                successmsg : '',
                errormsg : [],
                blankmsg : 'Fetching data..',
                fdata : {id:null, type:'0', priority:'0', message:''},
                

                showoverlay : false,
                showoverlaymodal : false,

                types: [                    
                    { value: "0", text: "Info" },
                    { value: "1", text: "Notice" },
                    { value: "2", text: "Message" },
                    { value: "3", text: "Alert" },
                ],
                
                prioritys: [                    
                    { value: "0", text: "Normal" },
                    { value: "1", text: "Urgent" },
                    { value: "2", text: "Critical" },
                ],

                length: 10,
                pagination: {currentPage: 1,total: '',nextPage: '',prevPage: '',from: '',to: '', pages:1},
                
            }
        },
        methods:{
            getAcl: function()
            {                
                axios.get(this.$api_url+'/acl' , {
                    params: {
                        url: this.cu
                    }
                }).then(function(response){
                    this.ce = response.data;                    
                }.bind(this));
            },
            getMessages: function()
            {
                if(!this.checkNet()) return false;
                this.showoverlay = true;
                axios.get(this.$api_url+'/system/message/list' , {
                    params: {
                        //employee_id: this.employeeId
                    }
                }).then(function(response){
                    //console.log(response.data);
                    this.messages = response.data;
                    this.pagination.total = response.data.length;

                    this.showoverlay = false;

                    if(this.messages.length == 0)
                        this.blankmsg = "Nothing found.";
                }.bind(this));
            }, 
            editMsg:function(x)
            { 
                if(!this.checkNet()) return false;
                let currentObj = this;
                     
                this.errormsg = [];
                this.successmsg = '';
                axios.get(this.$api_url+'/system/message/details' , {
                    params: {
                        id: x
                    }
                }).then(function(response){
                    this.fdata = response.data;
                    this.$validator.reset();
                }.bind(this))
                .catch(function (error)
                {
                    currentObj.serverError(error);
                });

                this.$bvModal.show('bv-modal-example');
                
            },
            deleteMsg:function(x)
            {

            },
            validateState(ref)
            {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },
            resetForm()
            {
                this.fdata = {id:null, type:'0', priority:'0', message:''};
                
                this.$nextTick(() => {
                    this.$validator.reset();
                });

                this.$nextTick(() => {
                    this.$validator.reset();
                });
            },
            addNewMsg()
            {
                this.resetForm();
                this.$bvModal.show('bv-modal-example');
            },
            onSubmit(e) 
            {
                if(!this.checkNet()) return false;
                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return;
                    }
                    //this.showoverlaymodal = true;
                    e.preventDefault();
                    let currentObj = this;
                    

                    let formData = new FormData();
                    
                    for (let [key, value] of Object.entries(this.fdata)) 
                    {                    
                        var nm = `${key}`;
                        var fval = `${value}`;
                        formData.append(nm, fval);                    
                        //console.log(`${key}: ${value}`);
                    } 

                    axios.post(this.$api_url+'/system/message/details', formData)
                                .then(function (response) 
                                {                             
                                    this.messages = response.data;
                                    this.$bvToast.toast('Saved!', {
                                            title: `Success`,
                                            variant: 'success',
                                            solid: true
                                        }); 

                                    this.$bvModal.hide('bv-modal-example');
                                    this.showoverlaymodal = false;                                    
                                    this.resetForm();
                                    
                                }.bind(this))
                                .catch(function (error) 
                                {                                    
                                    currentObj.serverError(error);
                                    currentObj.errormsg = error.response.data.errors;                                    
                                    for (var data in currentObj.errormsg)
                                    {
                                        var msg = currentObj.errormsg[data];
                                        currentObj.$bvToast.toast(msg, {
                                            title: `Error`,
                                            variant: 'danger',
                                            solid: true
                                        }); 
                                        currentObj.$validator.reset();
                                    }
                                });
                });
            },


        },
        created: function(){
            this.getAcl();
            this.getMessages();
            Fire.$on('reloadUsers', () => {this.getMessages()})
        },
        computed: 
        {
            filteredData() 
            {
                let filtered_list = this.messages;
                if (this.search) 
                {
                    filtered_list = filtered_list.filter((row) => {return Object.keys(row).some((key) => {return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;})});
                
                    if(filtered_list.length == 0)
                        this.blankmsg = "Nothing found.";                
                }
                
                return filtered_list;
            },
            paginatedData() 
            {     
                return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
            }
        }
    }
</script>